import { render, staticRenderFns } from "./IconReward.vue?vue&type=template&id=a14a89d2"
import script from "./IconReward.vue?vue&type=script&lang=js"
export * from "./IconReward.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports